module.exports = __webpack_public_path__ + "static/media/20190605_172049.40715dc7.jpg";